<div class="fixed inset-0 bg-black/60 flex justify-center items-center z-50"
  (click)="isSubmitting() ? null : close.emit()">
  <div class="bg-card rounded-lg shadow-xl w-full max-w-md p-6 m-4 border border-border"
    (click)="$event.stopPropagation()">
    <h3 class="text-lg font-bold text-foreground">{{ title() }}</h3>
    <p class="text-sm text-muted-foreground my-4" [innerHTML]="message()"></p>
    <ng-content></ng-content>
    <div class="mt-6 flex justify-end gap-3">
      <button type="button" (click)="close.emit()" [disabled]="cancelDisabled() || isSubmitting()"
        class="bg-secondary text-secondary-foreground px-4 py-2 rounded-md border border-border text-sm font-semibold hover:bg-secondary/80 disabled:opacity-50 disabled:cursor-not-allowed">{{ cancelText() }}</button>
      <button type="button" (click)="confirm.emit()" [disabled]="confirmDisabled() || isSubmitting()"
        class="text-white px-4 py-2 rounded-md text-sm font-semibold disabled:opacity-50 disabled:cursor-not-allowed"
        [ngClass]="confirmClass()">
        @if (isSubmitting()) {
        <i class="fa-solid fa-circle-notch fa-spin mr-2"></i>
        }
        {{ confirmText() }}
      </button>
    </div>
  </div>
</div>
